
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface LoadingStateProps {
  onLogout: () => void;
}

const LoadingState: React.FC<LoadingStateProps> = ({ onLogout }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header isLoggedIn={true} isAdmin={false} onLogout={onLogout} />
      <div className="flex-grow flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-blue mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading your profile...</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoadingState;
